import type { TFunction } from 'i18next'

import { getDevicePackageDefinition, isDevicePackageKey } from '../constants/devicePackages'
import type { VersionOption } from '../types/version'

export const getDevicePackageDisplayName = (
    packageKey: string | null | undefined,
    fallbackName: string | null | undefined,
    t: TFunction
): string => {
    if (isDevicePackageKey(packageKey)) {
        return t(`device:${getDevicePackageDefinition(packageKey).labelI18nKey}`, {
            defaultValue: packageKey,
        })
    }

    return fallbackName || packageKey || '-'
}

export const getDevicePackageOptionDisplayName = (
    option: VersionOption,
    t: TFunction
): string => getDevicePackageDisplayName(option.key, option.name || option.value, t)

export const getDevicePackageDescription = (
    packageKey: string | null | undefined,
    fallbackDescription: string | null | undefined,
    t: TFunction
): string => {
    if (isDevicePackageKey(packageKey)) {
        return t(`device:${getDevicePackageDefinition(packageKey).descriptionI18nKey}`, {
            defaultValue: packageKey,
        })
    }

    return fallbackDescription || packageKey || '-'
}
